import React from 'react';
import { CellContext } from '@tanstack/table-core';

import { CheckIcon, CrossIcon } from '../../../../../assets';

export interface IBooleanCellProps {
    cell: CellContext<any, boolean | null | undefined>;
}

export const BooleanCell = ({ cell }: IBooleanCellProps) => {
    const value = cell.getValue();
    if (value === null || value === undefined) {
        return null;
    }

    return value ? (
        <CheckIcon height={20} width={20} color="var(--color-green-600)" style={{ margin: 'auto' }} />
    ) : (
        <CrossIcon height={20} width={20} color="var(--color-red-600)" style={{ margin: 'auto' }} />
    );
};
